module.exports = __webpack_public_path__ + "static/media/transactionEmptyState.b42262fe.svg";